import { ApolloProvider } from '@apollo/client/react/index.js';
import { RouterProvider } from 'react-router';

import { apolloClient } from './lib/apollo.js';
import { router } from './router.js';

import type { ReactElement } from 'react';

export function App(): ReactElement {
  return (
    <ApolloProvider client={apolloClient}>
      <RouterProvider router={router} />
    </ApolloProvider>
  );
}
